/** @format */
import User from '../../dao/User';
import { put } from 'redux-saga/effects';
import { notify } from 'src/utils/utilitys';

export function* authWatcher(action) {
  try {
    // let result = yield User.login(action.data.email, action.data.password);
    // let { profile } = yield User.getByID(result.id);
    // let name = `${profile.first_name} ${profile.last_name}`;
    // localStorage.name = name;
    // yield put({ type: "AUTH_SET", auth: { ...result, name } });
    // localStorage.token = result.token;
    // localStorage.id = result.id;
    // localStorage.role = result.role;
    // localStorage.email = profile.email;

    try {
      let result = yield User.login(action.data.email, action.data.password);

      localStorage.token = result.token;
      localStorage.id = result.id;
      localStorage.role = result.role;
      let { profile } = yield User.getByID(result.id);
      localStorage.email = profile.email;
      let name = `${profile.first_name} ${profile.last_name}`;
      localStorage.name = name;
      yield put({ type: 'AUTH_SET', auth: { ...result, name } });
      notify({ status: 'success', title: `Welcome ${name}` });
    } catch (err) {
      console.log('err', err);
      notify({ status: 'error', title: err.error_message });
    }
  } catch (err) {
    console.log(err);
    // notify({ status: 'error', title: 'here' });
  }
}
